export const protocolMessages = {
  200: 'Acesso autorizado com sucesso.',
  400: 'Informações inválidas.',
  401: 'Acesso não autorizado.',
  403: 'Acesso proibido.',
  404: 'Nenhum resultado foi encontrado.',
  430: 'Usuário ou senha inválidos.',
  500: 'Erro interno no servidor.',
  501: 'Não implementado.',
  502: 'Bad Gateway.',
  503: 'Serviço indisponível.',
  504: 'Tempo limite do Gateway.',
};
